import { Stack, Avatar, Typography, useTheme } from '@mui/material';
import { ManualAccountType } from '../accountTypeData';
import { ClassificationItem } from '../categories.utility';

interface AccountTypeCardProps {
  accountType: ManualAccountType;
  selectedClassification: ClassificationItem | null;
  handleClassificationClick: (classification: ClassificationItem) => void;
}

const AccountTypeCard = ({
  accountType,
  selectedClassification,
  handleClassificationClick,
}: AccountTypeCardProps) => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';

  const defaultStyles = {
    border: '1px solid rgba(0,0,0,0.09)',
    bgcolor: 'rgba(0,0,0,0.04)',
    borderRadius: '4px',
    cursor: 'pointer',
    '&:hover': {
      bgcolor: 'rgba(0,0,0,0.08)',
    },
  };

  const selectedStyles = {
    ...defaultStyles,
    border: '1px solid rgba(0,0,0,0.09)',
    borderColor: 'primary.main',
  };

  const isSelected =
    (selectedClassification?.uiKey &&
      accountType.uiKey &&
      selectedClassification.uiKey === accountType.uiKey) ||
    (!selectedClassification?.uiKey &&
      !accountType.uiKey &&
      selectedClassification?.ClassificationId ===
        accountType.ClassificationId);

  return (
    <Stack
      direction='row'
      height='100px'
      alignItems='center'
      px={2}
      gap={2}
      sx={isSelected ? selectedStyles : defaultStyles}
      onClick={() => handleClassificationClick(accountType)}
    >
      <Avatar
        sx={{
          width: 60,
          height: 60,
          bgcolor: isDarkMode ? 'rgba(255, 255, 255, 0.08)' : 'white',
        }}
      >
        {accountType.icon}
      </Avatar>
      <Typography variant='h6'>{accountType.Name}</Typography>
    </Stack>
  );
};

export default AccountTypeCard;
